import React, { useState, useContext } from 'react';
import { CSSTransition } from 'react-transition-group';
import { createGlobalStyle } from 'styled-components';
import { ToolBar } from '../pageElements';
import { Button, ButtonFilled, Icon, ScrollView } from '../ui';
import EntryCaption from './EntryCaption';
import EntryContent from './EntryContent';
import EntryMeasurements from './EntryMeasurements';
import PanelNav from './PanelNav';
import { DateSelect } from '../forms';
import { isToday } from 'date-fns';
import { EditorContext } from './EditorContext';
import { back } from '../../lib/helpers/navigate';

const PanelAnimationCSS = createGlobalStyle`
.side-panel-enter {
  width: 0;
}
.side-panel-enter-active {
  width: 40vw;
  transition: all linear 250ms;
}
.side-panel-exit {
  width: 40vw;
  opacity: 1;
}
.side-panel-exit-active {
  width: 0;
  opacity: 0;
  transition: all linear 250ms;
}
`;

const NotSmall: React.FC = () => {
  const initialActiveTab = 'CAPTION';
  const [activeTab, setActiveTab] = useState<'CAPTION' | 'NOTE'>(initialActiveTab);
  const [showPanel, setShowPanel] = useState(true);
  const { dispatch, state } = useContext(EditorContext);

  return (
    <>
      <ToolBar className="justify-between ph3 bb b--light-gray">
        <button className="ph2" onClick={() => back()} data-testid="cancel-note-button">
          <Icon name="close" />
        </button>
        <ButtonFilled
          onClick={() => dispatch({ type: 'saveEntry' })}
          data-testid="save-note-button"
        >
          Save
        </ButtonFilled>
      </ToolBar>
      <div className="relative flex flex-auto transition">
        <PanelAnimationCSS />

        {/* Note measurements */}
        <ScrollView className="flex-auto w-100 pv4 pv5-ns transition">
          <div className="mw6-ns center ph3 ph0-l transition">
            <EntryMeasurements />
          </div>
        </ScrollView>

        <CSSTransition in={showPanel} classNames="side-panel" timeout={350} unmountOnExit={true}>
          <div className="bl b--light-gray flex-none">
            <div className="flex-none flex flex-column h-100" style={{ width: '40vw' }}>
              <ScrollView className="ph4 flex-auto">
                <PanelNav
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  setShowPanel={setShowPanel}
                />
                {activeTab === 'CAPTION' && <EntryCaption />}
                {activeTab === 'NOTE' && <EntryContent />}
              </ScrollView>

              <div className="pa4 bt b--light-gray">
                <div className="flex items-center justify-between mb3">
                  <p className="f6 mv0">Entry Date</p>
                  {!isToday(state.input.notedAt as Date) && (
                    <button
                      className="f7 blue hover-navy"
                      onClick={() => dispatch({ type: 'selectEntryDate', value: new Date() })}
                    >
                      Reset
                    </button>
                  )}
                </div>
                <DateSelect
                  selectedDate={state.input.notedAt}
                  setSelectedDate={(value: Date) => dispatch({ type: 'selectEntryDate', value })}
                />
              </div>
            </div>
          </div>
        </CSSTransition>

        {!showPanel && (
          <button
            className="absolute right-0 ph4"
            style={{ top: 57 }}
            onClick={() => setShowPanel(true)}
          >
            <Icon name="panel-toggle" className="rotate-180" />
          </button>
        )}
      </div>
    </>
  );
};

export default NotSmall;
